<article
  class="tw-flex tw-flex-col tw-content-around tw-justify-around tw-p-8 tw-relative tw-bg-white tw-shadow-lg tw-rounded-lg tw-overflow-hidden tw-w-full tw-h-full tw-mx-auto">
  <!-- Close button -->
  <i class="far fa-times fa-lg tw-cursor-pointer tw-absolute tw-right-4 tw-top-3 tw-text-gray-500" (click)="close()"></i>

  <!-- Title -->
  <section class="tw-text-center tw-rounded-t-lg">
    <h1 class="tw-text-2xl tw-font-semibold tw-text-gray-800">{{ customTitle | translate | titlecase }}</h1>
  </section>

  <!-- Description -->
  <section class="tw-px-8 tw-py-4 tw-text-center tw-text-gray-600 tw-text-lg tw-w-3/4 tw-mx-auto"
    [mhTooltip]="tooltipDescription">
    <p class="tw-text-center first-letter:tw-uppercase">
      <span *ngIf="data.hotelName" class="tw-font-bold !tw-font-[Rubik]">{{ data.hotelName }}</span>
      <ng-container *ngIf="showCoverage">
        {{ customHasA | translate }}
        <span class="tw-font-bold tw-font-[Rubik] text-status-{{ status }}">{{ coverage | formatPercent: true:false:true }}</span>
      </ng-container>
      &ngsp;<span class="!tw-font-[Rubik]" [innerHTML]="customDescription"></span>
      <span class="tw-font-bold !tw-font-[Rubik]">{{ currentDateFilter | translate | lowercase }}</span>.
    </p>
  </section>

  <section class="tw-px-6 tw-py-4 tw-bg-white tw-mx-auto tw-w-full tw-overflow-auto">
    <ng-container *ngIf="tableRows.length || !tableEmptyMessage">
      <table class="tw-w-full tw-text-left tw-border-collapse">
        <!-- Encabezados dinámicos -->
        <thead>
          <tr>
            <th *ngFor="let header of tableHeaders" [class]="header.cssClass" [style.width]="header.width">
              {{ header.translateKey | translate }}
            </th>
          </tr>
        </thead>
        <!-- Filas dinámicas -->
        <tbody>
          <tr *ngFor="let row of tableRows; let last = last" [class.tw-border-b]="!last" [class]="row.cssClass">
            <!-- Usamos las claves dinámicas de las celdas para renderizar cada celda -->
            <ng-container *ngFor="let key of getKeys(row.cells); let isFirst = first; let isLast = last">
              <td [class]="row.cells[key].cssClass" [class.tw-border-b]="!last"
                  [attr.position]="row.cells[key].tooltip ? (isFirst ? 'left' : (isLast ? 'right' : '')) : null"
                  [mhTooltip]="row.cells[key].tooltip ? (row.cells[key].tooltip | translate:row.cells[key].tooltipParams) : null"
                  [mhBlurContent]="shouldBlurRow(row.id)">

                <!-- Verificamos si la celda es de tipo botón -->
                <ng-container *ngIf="row.cells[key].type === 'button'; else normalCellTemplate">
                  <mh-core-lib-button
                    [mhTooltip]="(currentUser.isSuperAdmin() && !row.cells[key].allowSuperAdmin) ? ('followup.summary.data-rate.tooltip_activation' | translate) : (row.cells[key].labelTooltip) | translate"
                    [text]="row.translateKey | translate"
                    [isSecondary]="true"
                    [height]="25"
                    [width]="'tw-w-fit'"
                    [customClass]="'!tw-shadow-none tw-text-sm tw-whitespace-nowrap {{ row.cells[key].buttonClass }}'"
                    [isDisabled]="!isAdmin || (currentUser.isSuperAdmin() && !row.cells[key].allowSuperAdmin)"
                    (clicked)="row.cells[key].onClick()"
                    (clicked)="utilService.ga('event', 'click', data.widgetKey + '-datamodal-button-click')"
                  >{{ row.cells[key].value | translate }}</mh-core-lib-button>
                </ng-container>

                <!-- Template para celdas normales -->
                <ng-template #normalCellTemplate>
                  <!-- El valor principal de la celda -->
                  <ng-container *ngIf="!row.cells[key].isPercentage; else percentageTemplate">
                    <span *ngIf="!row.cells[key].addPercentage" class="tw-font-[Rubik]">{{ row.cells[key].value | translate }}</span>
                    <span *ngIf="row.cells[key].addPercentage" class="tw-font-[Rubik]">{{ row.cells[key].value | formatPercent: true:false:true }}</span>
                  </ng-container>

                  <!-- Template para porcentajes con colores condicionales -->
                  <ng-template #percentageTemplate>
                    <span class="tw-font-[Rubik]">{{ row.cells[key].value  }}</span>
                    <ng-container *ngIf="data.pms">
                      <span class="tw-font-[Rubik]" [ngClass]="getColorClass(row.cells[key])">
                        ({{ row.cells[key].coverage | formatPercent: true:false:true }})
                      </span>
                    </ng-container>
                  </ng-template>
                </ng-template>
              </td>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </ng-container>
    <p *ngIf="!tableRows.length && tableEmptyMessage"
       class="tw-py-6 tw-text-center tw-text-gray-500 !tw-font-[Rubik]">
      {{ tableEmptyMessage | translate }}
    </p>
  </section>

  <section *ngIf="showWarnMessage"  class="tw-mt-4 tw-bg-amber-50 tw-px-10 tw-py-4 tw-rounded-lg tw-flex tw-items-center tw-gap-6 tw-h-auto">
    <span class="tw-text-3xl">{{ customImproveIcon }}</span>
    <p class="tw-text-sm !tw-font-[Rubik] tw-py-2" [innerHTML]="safeImproveText" (click)="onImproveTextClick($event)"></p>
  </section>

</article>
